// plugins/moment.js

import Vue from "vue";
import moment from "moment";

// Assign moment to Vue's prototype
Vue.prototype.$moment = moment;
